import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { CheckoutPlaceOrderComponent, CheckoutAuthGuard, CartNotEmptyGuard } from '@spartacus/checkout/base/components';
import * as i1 from '@spartacus/order/root';
import { DaysOfWeek, recurrencePeriod, ORDER_TYPE } from '@spartacus/order/root';
import { Subscription, BehaviorSubject, merge } from 'rxjs';
import * as i2 from '@spartacus/core';
import { LogoutEvent, LoginEvent, UrlModule, I18nModule, provideDefaultConfig, useFeatureStyles, FeaturesConfigModule } from '@spartacus/core';
import * as i3 from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import * as i4 from '@spartacus/storefront';
import { AtMessageModule, ICON_TYPE, IconModule } from '@spartacus/storefront';
import { MergeCartSuccessEvent } from '@spartacus/cart/base/root';
import { SaveCartSuccessEvent, RestoreSavedCartSuccessEvent } from '@spartacus/cart/saved-cart/root';
import { CheckoutDeliveryAddressSetEvent, CheckoutDeliveryAddressClearedEvent, CheckoutDeliveryModeSetEvent, CheckoutDeliveryModeClearedEvent, CheckoutPaymentDetailsCreatedEvent, CheckoutPaymentDetailsSetEvent } from '@spartacus/checkout/base/root';
import * as i6 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i2$1 from '@angular/common';
import { CommonModule } from '@angular/common';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const _c0 = () => ({
  cxRoute: "termsAndConditions"
});
function CheckoutScheduleReplenishmentOrderComponent_h3_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "checkoutScheduledReplenishment.autoReplenishOrder"), " ");
  }
}
function CheckoutScheduleReplenishmentOrderComponent_h5_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "checkoutScheduledReplenishment.autoReplenishOrder"), " ");
  }
}
function CheckoutScheduleReplenishmentOrderComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "input", 11);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("change", function CheckoutScheduleReplenishmentOrderComponent_div_5_Template_input_change_1_listener() {
      const type_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeOrderType(type_r2.value));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 12)(4, "div", 13);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const type_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "orderType-", type_r2.value, "");
    i0.ɵɵproperty("value", type_r2.value)("checked", type_r2.value === i0.ɵɵpipeBind1(2, 7, ctx_r2.selectedOrderType$));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("for", "orderType-", type_r2.value, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 9, "checkoutScheduledReplenishment.orderType_" + (type_r2 == null ? null : type_r2.value)), " ");
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "checkoutScheduledReplenishment.every"));
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_label_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 29);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "checkoutScheduledReplenishment.every"));
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_ng_container_3_option_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const nWeeks_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("value", nWeeks_r6)("selected", nWeeks_r6 === ctx_r2.scheduleReplenishmentFormData.numberOfWeeks);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", nWeeks_r6, " ");
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "select", 30);
    i0.ɵɵlistener("change", function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_ng_container_3_Template_select_change_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.changeNumberOfWeeks($event.target.value));
    });
    i0.ɵɵtemplate(2, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_ng_container_3_option_2_Template, 2, 3, "option", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.numberOfWeeks);
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_ng_template_4_option_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const nDays_r8 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("value", nDays_r8)("selected", nDays_r8 === ctx_r2.scheduleReplenishmentFormData.numberOfDays);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", nDays_r8, " ");
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 30);
    i0.ɵɵlistener("change", function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_ng_template_4_Template_select_change_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.changeNumberOfDays($event.target.value));
    });
    i0.ɵɵtemplate(1, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_ng_template_4_option_1_Template, 2, 3, "option", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.numberOfDays);
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_span_1_Template, 3, 3, "span", 22)(2, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_label_2_Template, 3, 3, "label", 26)(3, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_ng_container_3_Template, 3, 1, "ng-container", 27)(4, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_ng_template_4_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const isDaily_r9 = i0.ɵɵreference(5);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yScheduleReplenishment");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yScheduleReplenishment");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isWeekly)("ngIfElse", isDaily_r9);
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_4_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "checkoutScheduledReplenishment.every"));
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_4_span_1_Template, 3, 3, "span", 32);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isMonthly);
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_5_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 34);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "checkoutScheduledReplenishment.every"));
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_5_label_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 34);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "checkoutScheduledReplenishment.duration"));
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_5_label_1_Template, 3, 3, "label", 33)(2, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_5_label_2_Template, 3, 3, "label", 33);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isMonthly);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.isMonthly);
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_option_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 31);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const type_r10 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", type_r10)("selected", type_r10 === ctx_r2.scheduleReplenishmentFormData.recurrencePeriod);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "checkoutScheduledReplenishment.recurrencePeriodType_" + type_r10), " ");
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_8_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "checkoutScheduledReplenishment.dayOfMonth"));
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_8_label_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 39);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "checkoutScheduledReplenishment.dayOfMonth"));
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_8_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const nDays_r12 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", nDays_r12)("selected", nDays_r12 === ctx_r2.scheduleReplenishmentFormData.nthDayOfMonth);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", nDays_r12, " ");
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_8_span_1_Template, 3, 3, "span", 22)(2, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_8_label_2_Template, 3, 3, "label", 36);
    i0.ɵɵelementStart(3, "div", 37)(4, "select", 38);
    i0.ɵɵlistener("change", function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_8_Template_select_change_4_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.changeDayOfTheMonth($event.target.value));
    });
    i0.ɵɵtemplate(5, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_8_option_5_Template, 2, 3, "option", 19);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yScheduleReplenishment");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yScheduleReplenishment");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.numberOfDays);
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_label_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 40);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "checkoutScheduledReplenishment.startOn"));
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_span_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "checkoutScheduledReplenishment.startOn"));
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_14_fieldset_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45)(1, "label", 46);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 47);
    i0.ɵɵlistener("change", function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_14_fieldset_1_div_4_Template_input_change_4_listener($event) {
      const day_r14 = i0.ɵɵrestoreView(_r13).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.changeRepeatDays(day_r14, $event.target.checked));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const day_r14 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("for", "day-", day_r14, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 6, day_r14));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "day-", day_r14, "");
    i0.ɵɵproperty("checked", ctx_r2.hasDaysOfWeekChecked(day_r14));
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_14_fieldset_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "fieldset", 42)(1, "legend", 43);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_14_fieldset_1_div_4_Template, 5, 8, "div", 44);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "checkoutScheduledReplenishment.repeatOnDays"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.daysOfWeek);
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_14_fieldset_1_Template, 5, 4, "fieldset", 41);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isWeekly);
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_15_div_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45)(1, "label", 46);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 47);
    i0.ɵɵlistener("change", function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_15_div_1_div_4_Template_input_change_4_listener($event) {
      const day_r16 = i0.ɵɵrestoreView(_r15).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.changeRepeatDays(day_r16, $event.target.checked));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const day_r16 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("for", "day-", day_r16, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 6, day_r16));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "day-", day_r16, "");
    i0.ɵɵproperty("checked", ctx_r2.hasDaysOfWeekChecked(day_r16));
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_15_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42)(1, "span", 43);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_15_div_1_div_4_Template, 5, 8, "div", 44);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "checkoutScheduledReplenishment.repeatOnDays"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.daysOfWeek);
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_15_div_1_Template, 5, 4, "div", 41);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isWeekly);
  }
}
function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵtemplate(2, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_2_Template, 6, 4, "div", 15);
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵtemplate(4, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_4_Template, 2, 1, "ng-container", 17)(5, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_5_Template, 3, 2, "ng-container", 17);
    i0.ɵɵelementStart(6, "select", 18);
    i0.ɵɵlistener("change", function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_Template_select_change_6_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeRecurrencePeriodType($event.target.value));
    });
    i0.ɵɵtemplate(7, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_option_7_Template, 3, 5, "option", 19);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_div_8_Template, 6, 3, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 14);
    i0.ɵɵtemplate(10, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_label_10_Template, 3, 3, "label", 21)(11, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_span_11_Template, 3, 3, "span", 22);
    i0.ɵɵelementStart(12, "div", 23)(13, "input", 24);
    i0.ɵɵlistener("change", function CheckoutScheduleReplenishmentOrderComponent_ng_container_7_Template_input_change_13_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeReplenishmentStartDate($event.target.value));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(14, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_14_Template, 2, 1, "ng-container", 17)(15, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_ng_container_15_Template, 2, 1, "ng-container", 17);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.isMonthly);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "!a11yScheduleReplenishment");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yScheduleReplenishment");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.recurrencePeriodType);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isMonthly);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yScheduleReplenishment");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yScheduleReplenishment");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r2.currentDate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yReplenishmentOrderFieldset");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yReplenishmentOrderFieldset");
  }
}
let CheckoutReplenishmentFormService = /*#__PURE__*/(() => {
  class CheckoutReplenishmentFormService {
    constructor(eventService) {
      this.eventService = eventService;
      this.subscriptions = new Subscription();
      /**
       * Default form data
       */
      this.defaultFormData = {
        daysOfWeek: [DaysOfWeek.MONDAY],
        nthDayOfMonth: '1',
        numberOfDays: '14',
        numberOfWeeks: '1',
        recurrencePeriod: recurrencePeriod.DAILY,
        replenishmentStartDate: new Date().toISOString().split('T')[0]
      };
      this.scheduleReplenishmentFormData$ = new BehaviorSubject(this.defaultFormData);
      this.orderType$ = new BehaviorSubject(ORDER_TYPE.PLACE_ORDER);
      this.registerOrderTypeEventListers();
    }
    registerOrderTypeEventListers() {
      this.subscriptions.add(merge(this.eventService.get(CheckoutDeliveryAddressSetEvent), this.eventService.get(CheckoutDeliveryAddressClearedEvent), this.eventService.get(CheckoutDeliveryModeSetEvent), this.eventService.get(CheckoutDeliveryModeClearedEvent), this.eventService.get(CheckoutPaymentDetailsCreatedEvent), this.eventService.get(CheckoutPaymentDetailsSetEvent), this.eventService.get(LogoutEvent), this.eventService.get(LoginEvent), this.eventService.get(SaveCartSuccessEvent), this.eventService.get(RestoreSavedCartSuccessEvent), this.eventService.get(MergeCartSuccessEvent)).subscribe(() => {
        this.orderType$.next(ORDER_TYPE.PLACE_ORDER);
      }));
    }
    /**
     * Get replenishment form data
     */
    getScheduleReplenishmentFormData() {
      return this.scheduleReplenishmentFormData$;
    }
    /**
     * Set replenishment form data
     * @param formData : an object containing the data for scheduling a replenishment order
     */
    setScheduleReplenishmentFormData(formData) {
      this.scheduleReplenishmentFormData$.next(formData);
    }
    /**
     * Clears the existing replenishment form data to include the default replenishment form data
     */
    resetScheduleReplenishmentFormData() {
      this.scheduleReplenishmentFormData$.next(this.defaultFormData);
    }
    /**
     * Get current checkout order type
     */
    getOrderType() {
      return this.orderType$;
    }
    /**
     * Set checkout order type
     * @param orderType : an enum of types of order we are placing
     */
    setOrderType(orderType) {
      this.orderType$.next(orderType);
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }
    static {
      this.ɵfac = function CheckoutReplenishmentFormService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutReplenishmentFormService)(i0.ɵɵinject(i2.EventService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutReplenishmentFormService,
        factory: CheckoutReplenishmentFormService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CheckoutReplenishmentFormService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutScheduledReplenishmentPlaceOrderComponent = /*#__PURE__*/(() => {
  class CheckoutScheduledReplenishmentPlaceOrderComponent extends CheckoutPlaceOrderComponent {
    constructor(orderFacade, routingService, fb, launchDialogService, vcr, checkoutReplenishmentFormService, scheduledReplenishmentOrderFacade) {
      super(orderFacade, routingService, fb, launchDialogService, vcr);
      this.orderFacade = orderFacade;
      this.routingService = routingService;
      this.fb = fb;
      this.launchDialogService = launchDialogService;
      this.vcr = vcr;
      this.checkoutReplenishmentFormService = checkoutReplenishmentFormService;
      this.scheduledReplenishmentOrderFacade = scheduledReplenishmentOrderFacade;
      this.subscriptions = new Subscription();
      this.daysOfWeekNotChecked$ = new BehaviorSubject(false);
    }
    submitForm() {
      if (this.checkoutSubmitForm.valid && !!this.currentOrderType) {
        this.placedOrder = this.launchDialogService.launch("PLACE_ORDER_SPINNER" /* LAUNCH_CALLER.PLACE_ORDER_SPINNER */, this.vcr);
        merge(this.currentOrderType === ORDER_TYPE.PLACE_ORDER ? this.orderFacade.placeOrder(this.checkoutSubmitForm.valid) : this.scheduledReplenishmentOrderFacade.scheduleReplenishmentOrder(this.scheduleReplenishmentFormData, this.checkoutSubmitForm.valid)).subscribe({
          error: () => {
            if (this.placedOrder) {
              this.placedOrder.subscribe(component => {
                this.launchDialogService.clear("PLACE_ORDER_SPINNER" /* LAUNCH_CALLER.PLACE_ORDER_SPINNER */);
                if (component) {
                  component.destroy();
                }
              }).unsubscribe();
            }
          },
          next: () => {
            this.onSuccess();
          }
        });
      } else {
        this.checkoutSubmitForm.markAllAsTouched();
      }
    }
    ngOnInit() {
      this.subscriptions.add(this.checkoutReplenishmentFormService.getOrderType().subscribe(orderType => this.currentOrderType = orderType));
      this.subscriptions.add(this.checkoutReplenishmentFormService.getScheduleReplenishmentFormData().subscribe(data => {
        this.scheduleReplenishmentFormData = data;
        this.daysOfWeekNotChecked$.next(data.daysOfWeek?.length === 0 && data.recurrencePeriod === recurrencePeriod.WEEKLY);
      }));
    }
    onSuccess() {
      switch (this.currentOrderType) {
        case ORDER_TYPE.PLACE_ORDER:
          {
            super.onSuccess();
            break;
          }
        case ORDER_TYPE.SCHEDULE_REPLENISHMENT_ORDER:
          {
            this.routingService.go({
              cxRoute: 'replenishmentConfirmation'
            });
            break;
          }
      }
      this.checkoutReplenishmentFormService.resetScheduleReplenishmentFormData();
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
      super.ngOnDestroy();
    }
    static {
      this.ɵfac = function CheckoutScheduledReplenishmentPlaceOrderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutScheduledReplenishmentPlaceOrderComponent)(i0.ɵɵdirectiveInject(i1.OrderFacade), i0.ɵɵdirectiveInject(i2.RoutingService), i0.ɵɵdirectiveInject(i3.UntypedFormBuilder), i0.ɵɵdirectiveInject(i4.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(CheckoutReplenishmentFormService), i0.ɵɵdirectiveInject(i1.ScheduledReplenishmentOrderFacade));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutScheduledReplenishmentPlaceOrderComponent,
        selectors: [["cx-place-order"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 16,
        vars: 20,
        consts: [[1, "cx-place-order-form", "form-check", 3, "formGroup"], [1, "form-group"], ["formControlName", "termsAndConditions", "type", "checkbox", 1, "scaled-input", "form-check-input"], [1, "form-check-label"], ["target", "_blank", "rel", "noopener noreferrer", 1, "cx-tc-link", 3, "routerLink"], [1, "btn", "btn-primary", "btn-block", 3, "click", "disabled", "cxAtMessage"]],
        template: function CheckoutScheduledReplenishmentPlaceOrderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0)(1, "div", 1)(2, "label");
            i0.ɵɵelement(3, "input", 2);
            i0.ɵɵelementStart(4, "span", 3);
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "cxTranslate");
            i0.ɵɵelementStart(7, "a", 4);
            i0.ɵɵpipe(8, "cxUrl");
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "cxTranslate");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(11, "button", 5);
            i0.ɵɵpipe(12, "async");
            i0.ɵɵpipe(13, "cxTranslate");
            i0.ɵɵlistener("click", function CheckoutScheduledReplenishmentPlaceOrderComponent_Template_button_click_11_listener() {
              return ctx.submitForm();
            });
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "cxTranslate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.checkoutSubmitForm);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 7, "checkoutReview.confirmThatRead"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(8, 9, i0.ɵɵpureFunction0(19, _c0)));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 11, "checkoutReview.termsAndConditions"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.termsAndConditionInvalid || i0.ɵɵpipeBind1(12, 13, ctx.daysOfWeekNotChecked$))("cxAtMessage", i0.ɵɵpipeBind1(13, 15, "checkoutReview.orderInProcess"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 17, "checkoutReview.placeOrder"), " ");
          }
        },
        dependencies: [i4.AtMessageDirective, i6.RouterLink, i3.ɵNgNoValidate, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.FormGroupDirective, i3.FormControlName, i2$1.AsyncPipe, i2.UrlPipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutScheduledReplenishmentPlaceOrderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutScheduledReplenishmentPlaceOrderModule = /*#__PURE__*/(() => {
  class CheckoutScheduledReplenishmentPlaceOrderModule {
    static {
      this.ɵfac = function CheckoutScheduledReplenishmentPlaceOrderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutScheduledReplenishmentPlaceOrderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutScheduledReplenishmentPlaceOrderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutPlaceOrder: {
              component: CheckoutScheduledReplenishmentPlaceOrderComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard]
            }
          }
        })],
        imports: [AtMessageModule, CommonModule, RouterModule, UrlModule, I18nModule, ReactiveFormsModule]
      });
    }
  }
  return CheckoutScheduledReplenishmentPlaceOrderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutScheduleReplenishmentOrderComponent = /*#__PURE__*/(() => {
  class CheckoutScheduleReplenishmentOrderComponent {
    constructor(checkoutReplenishmentFormService) {
      this.checkoutReplenishmentFormService = checkoutReplenishmentFormService;
      this.subscription = new Subscription();
      this.iconTypes = ICON_TYPE;
      this.orderTypes = ORDER_TYPE;
      this.daysOfWeek = Object.values(DaysOfWeek);
      this.recurrencePeriodType = Object.values(recurrencePeriod);
      this.selectedOrderType$ = this.checkoutReplenishmentFormService.getOrderType();
      this.isMonthly = false;
      this.isWeekly = false;
      this.currentDaysOfWeek = [];
      useFeatureStyles('a11yReplenishmentOrderFieldset');
      useFeatureStyles('a11yScheduleReplenishment');
    }
    ngOnInit() {
      this.subscription.add(this.checkoutReplenishmentFormService.getScheduleReplenishmentFormData().subscribe(data => {
        this.scheduleReplenishmentFormData = data;
      }));
      this.initConfig();
    }
    changeOrderType(orderType) {
      this.checkoutReplenishmentFormService.setOrderType(orderType);
    }
    changeNumberOfDays(nDays) {
      this.checkoutReplenishmentFormService.setScheduleReplenishmentFormData({
        ...this.scheduleReplenishmentFormData,
        numberOfDays: nDays
      });
    }
    changeNumberOfWeeks(nWeeks) {
      this.checkoutReplenishmentFormService.setScheduleReplenishmentFormData({
        ...this.scheduleReplenishmentFormData,
        numberOfWeeks: nWeeks
      });
    }
    changeRecurrencePeriodType(type) {
      this.isWeekly = type === recurrencePeriod.WEEKLY;
      this.isMonthly = type === recurrencePeriod.MONTHLY;
      this.numberOfDays = this.isMonthly ? this.createNumberStringArray(31) : this.createNumberStringArray(30);
      this.checkoutReplenishmentFormService.setScheduleReplenishmentFormData({
        ...this.scheduleReplenishmentFormData,
        recurrencePeriod: type
      });
    }
    changeDayOfTheMonth(dayOfMonth) {
      this.checkoutReplenishmentFormService.setScheduleReplenishmentFormData({
        ...this.scheduleReplenishmentFormData,
        nthDayOfMonth: dayOfMonth
      });
    }
    changeReplenishmentStartDate(date) {
      if (Boolean(date)) {
        this.checkoutReplenishmentFormService.setScheduleReplenishmentFormData({
          ...this.scheduleReplenishmentFormData,
          replenishmentStartDate: date
        });
      }
    }
    changeRepeatDays(day, isChecked) {
      if (isChecked) {
        this.currentDaysOfWeek = [...this.currentDaysOfWeek];
        this.currentDaysOfWeek.push(day);
        this.checkoutReplenishmentFormService.setScheduleReplenishmentFormData({
          ...this.scheduleReplenishmentFormData,
          daysOfWeek: this.currentDaysOfWeek
        });
      } else {
        const foundDay = this.currentDaysOfWeek.find(data => day === data);
        if (!foundDay) {
          return;
        }
        const index = this.currentDaysOfWeek.indexOf(foundDay);
        this.currentDaysOfWeek.splice(index, 1);
        this.checkoutReplenishmentFormService.setScheduleReplenishmentFormData({
          ...this.scheduleReplenishmentFormData,
          daysOfWeek: this.currentDaysOfWeek
        });
      }
    }
    hasDaysOfWeekChecked(day) {
      return this.currentDaysOfWeek.includes(day);
    }
    initConfig() {
      this.isMonthly = this.scheduleReplenishmentFormData.recurrencePeriod === recurrencePeriod.MONTHLY;
      this.isWeekly = this.scheduleReplenishmentFormData.recurrencePeriod === recurrencePeriod.WEEKLY;
      this.currentDaysOfWeek = [...(this.scheduleReplenishmentFormData.daysOfWeek ?? [])];
      this.numberOfDays = this.isMonthly ? this.createNumberStringArray(31) : this.createNumberStringArray(30);
      this.numberOfWeeks = this.createNumberStringArray(12);
      this.currentDate = this.scheduleReplenishmentFormData.replenishmentStartDate;
    }
    createNumberStringArray(n) {
      return Array(n).fill(0).map((_, y) => (y + 1).toString());
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static {
      this.ɵfac = function CheckoutScheduleReplenishmentOrderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutScheduleReplenishmentOrderComponent)(i0.ɵɵdirectiveInject(CheckoutReplenishmentFormService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutScheduleReplenishmentOrderComponent,
        selectors: [["cx-schedule-replenishment-order"]],
        standalone: false,
        decls: 9,
        vars: 10,
        consts: [["isDaily", ""], ["role", "region", 1, "cx-order-type-card"], [1, "cx-label-container"], ["id", "checkout-schedule-replenishment-order-title", "class", "cx-order-replenishment-header", 4, "cxFeature"], ["class", "cx-order-replenishment-header", 4, "cxFeature"], [3, "type"], ["class", "cx-order-type-container form-check", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["id", "checkout-schedule-replenishment-order-title", 1, "cx-order-replenishment-header"], [1, "cx-order-replenishment-header"], [1, "cx-order-type-container", "form-check"], ["role", "radio", "type", "radio", "formControlName", "orderType", "aria-checked", "true", 1, "scaled-input", "form-check-input", 3, "change", "id", "value", "checked"], [1, "order-type-label", "form-check-label", "form-radio-label", 3, "for"], [1, "order-type"], [1, "cx-replenishment-form-data-container"], ["class", "cx-days", 4, "ngIf"], [1, "cx-month"], [4, "cxFeature"], ["id", "order-replenishment-recurrence-period", 1, "form-control", 3, "change"], [3, "value", "selected", 4, "ngFor", "ngForOf"], ["class", "cx-dayMonth", 4, "ngIf"], ["for", "datepicker", "class", "form-data-label", 4, "cxFeature"], ["class", "form-data-label", 4, "cxFeature"], [1, "cx-replenishment-date"], ["id", "datepicker", "type", "date", "placeholder", "yyyy-mm-dd", 3, "change", "value"], [1, "cx-days"], ["class", "form-data-label", "for", "order-replenishment-period-type", 4, "cxFeature"], [4, "ngIf", "ngIfElse"], [1, "form-data-label"], ["for", "order-replenishment-period-type", 1, "form-data-label"], ["id", "order-replenishment-period-type", 1, "form-control", 3, "change"], [3, "value", "selected"], ["class", "form-data-label", 4, "ngIf"], ["class", "form-data-label", "for", "order-replenishment-recurrence-period", 4, "ngIf"], ["for", "order-replenishment-recurrence-period", 1, "form-data-label"], [1, "cx-dayMonth"], ["class", "form-data-label", "for", "order-replenishment-day-of-month", 4, "cxFeature"], [1, "cx-day-of-month"], ["id", "order-replenishment-day-of-month", 1, "form-control", 3, "change"], ["for", "order-replenishment-day-of-month", 1, "form-data-label"], ["for", "datepicker", 1, "form-data-label"], ["class", "cx-replenishment-form-data-container cx-repeat-days-container", 4, "ngIf"], [1, "cx-replenishment-form-data-container", "cx-repeat-days-container"], [1, "cx-repeat-days", "form-data-label"], ["class", "form-check", 4, "ngFor", "ngForOf"], [1, "form-check"], [1, "cx-week-day", 3, "for"], ["type", "checkbox", 1, "form-check-input", 3, "change", "id", "checked"]],
        template: function CheckoutScheduleReplenishmentOrderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵtemplate(2, CheckoutScheduleReplenishmentOrderComponent_h3_2_Template, 3, 3, "h3", 3)(3, CheckoutScheduleReplenishmentOrderComponent_h5_3_Template, 3, 3, "h5", 4);
            i0.ɵɵelement(4, "cx-icon", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, CheckoutScheduleReplenishmentOrderComponent_div_5_Template, 7, 11, "div", 6);
            i0.ɵɵpipe(6, "keyvalue");
            i0.ɵɵtemplate(7, CheckoutScheduleReplenishmentOrderComponent_ng_container_7_Template, 16, 10, "ng-container", 7);
            i0.ɵɵpipe(8, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵattribute("aria-labelledby", "checkout-schedule-replenishment-order-title");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "a11yScheduleReplenishment");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!a11yScheduleReplenishment");
            i0.ɵɵadvance();
            i0.ɵɵproperty("type", ctx.iconTypes.CLOCK);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(6, 6, ctx.orderTypes));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.scheduleReplenishmentFormData && i0.ɵɵpipeBind1(8, 8, ctx.selectedOrderType$) === ctx.orderTypes.SCHEDULE_REPLENISHMENT_ORDER);
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i4.IconComponent, i2.FeatureDirective, i2$1.AsyncPipe, i2$1.TitleCasePipe, i2$1.KeyValuePipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutScheduleReplenishmentOrderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutScheduleReplenishmentOrderModule = /*#__PURE__*/(() => {
  class CheckoutScheduleReplenishmentOrderModule {
    static {
      this.ɵfac = function CheckoutScheduleReplenishmentOrderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutScheduleReplenishmentOrderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutScheduleReplenishmentOrderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutScheduleReplenishmentOrder: {
              component: CheckoutScheduleReplenishmentOrderComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard]
            }
          }
        })],
        imports: [CommonModule, RouterModule, I18nModule, IconModule, FeaturesConfigModule]
      });
    }
  }
  return CheckoutScheduleReplenishmentOrderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutScheduledReplenishmentComponentsModule = /*#__PURE__*/(() => {
  class CheckoutScheduledReplenishmentComponentsModule {
    static {
      this.ɵfac = function CheckoutScheduledReplenishmentComponentsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutScheduledReplenishmentComponentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutScheduledReplenishmentComponentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, CheckoutScheduleReplenishmentOrderModule, CheckoutScheduledReplenishmentPlaceOrderModule]
      });
    }
  }
  return CheckoutScheduledReplenishmentComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CheckoutReplenishmentFormService, CheckoutScheduleReplenishmentOrderComponent, CheckoutScheduleReplenishmentOrderModule, CheckoutScheduledReplenishmentComponentsModule, CheckoutScheduledReplenishmentPlaceOrderComponent, CheckoutScheduledReplenishmentPlaceOrderModule };
